export default __webpack_public_path__ + "static/media/ursinebond.a0e40d7c.png";